import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TextBrandingStyleOption extends BaseOption {
  static userInterfaceComponent = {
    label: "Style",
    component: inspectorTools.SIMPLE_PICKER,
    canSetAsVariable: false,
    props: {
      options: [
        {
          id: "heading",
          name: "Heading",
        },
        {
          id: "subheading",
          name: "SubHeading",
        },
        {
          id: "title",
          name: "Title",
        },
        {
          id: "label",
          name: "Label",
        },
        {
          id: "paragraph",
          name: "Paragraph",
        },
        {
          id: "note",
          name: "Note",
        },
      ],
      // No sideEffect: the picker only writes
      // `text-branding-style-option` on the element. The element type
      // never changes — `TypographyBranding.determineType` reads this
      // option (along with `text-style-option`) and resolves the chain
      // lookup to the matching `BrandedXxxElement` row, so the
      // selected style applies via the brand chain without rewriting
      // the element's identity.
      //
      // This matches the way UrlElement uses the same picker (see
      // `BrandedTextStyleVariantOptions` / `branded-text-style-options`).
      // Previously the picker called `dynamicElement.updateType(...)`
      // which morphed BrandedHeadingElement → BrandedParagraphElement
      // (and friends) on every style flip — losing per-instance
      // history every time and inviting the same kind of legacy-option
      // breakage UrlElement hit before.
    },
  };

  static defaultValue = "paragraph";

  static VariantOptions = {
    "heading": "BrandedHeadingElement",
    "subheading": "BrandedSubHeadingElement",
    "title": "BrandedTitleElement",
    "label": "BrandedLabelElement",
    "paragraph": "BrandedParagraphElement",
    "note": "BrandedNoteElement",
  };
}
